import React, {useRef, useEffect, useState} from 'react';
import {DefaultButton} from "../resources/styles";
import styled from "styled-components";

const VideoContainer = styled.div`
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: black;
    z-index: 9999;
    justify-content: center;
    align-items: center;
`;

const CloseButton = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: none;
    padding: 10px;
    cursor: pointer;
`;

const Video = styled.video`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;



const CustomVideoContainer = ({videoUrl, onEndCallback}) => {

    const videoContainer = useRef(null);
    const video = useRef(null);
    const [hasStarted, setHasStarted] = useState(false);
    const [hasEnded, setHasEnded] = useState(false);

    useEffect(() => {
        if (video.current) {
            video.current.addEventListener("ended", closeVideo);
        }
    }, []);

    const openVideo = () => {
        videoContainer.current.style.display = "flex";
        video.current.play();
    }

    const closeVideo = () => {
        video.current.pause();
        if (video.current.currentTime > 0) {
            setHasStarted(true);
        }
        videoContainer.current.style.display = "none";
    }

    return (
        <div>
            <DefaultButton onClick={openVideo}>
                { hasEnded ? "Rewatch Video" : hasStarted ? "Resume Video" : "Play Video" }
            </DefaultButton>
            <VideoContainer ref={videoContainer}>
                <CloseButton onClick={closeVideo}>
                    Close Video
                </CloseButton>
                <Video
                    ref={video}
                    playsInline
                    onEnded={ () => {
                        onEndCallback();
                        setHasEnded(true);
                    }}
                >
                    <source src={videoUrl} type="video/mp4"/>
                    Your browser does not support HTML5 video.
                </Video>
            </VideoContainer>
        </div>
    )
};

export default CustomVideoContainer;
